import { getViewport, SMALL_VIEWPORT } from "../../../modules/layout";

export default function miniBagEnabled(state) {
  return getViewport(state) !== SMALL_VIEWPORT;
}
